import type { FC, ReactNode } from 'react'
import { createContext, useContext } from 'react'

type AIBotContextType = {
	isAIBot: boolean
}

const AIBotContext = createContext<AIBotContextType>({ isAIBot: false })

export const useAIBot = () => useContext(AIBotContext)

export const AIBotProvider: FC<AIBotContextType & { children: ReactNode }> = ({
	isAIBot,
	children,
}) => {
	return (
		<AIBotContext.Provider value={{ isAIBot }}>
			{children}
		</AIBotContext.Provider>
	)
}
